module.exports = "/lucky-balls/img/bonus_yellow/header_elbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_elbet.png
// module id = 966
// module chunks = 0